// extracted by mini-css-extract-plugin
export var backgroundImage = "SectionImageLeftSupport-module--background-image--b12b2";
export var content = "SectionImageLeftSupport-module--content--805ae";
export var contentWrapper = "SectionImageLeftSupport-module--contentWrapper--ce2b9";
export var ctaWrapper = "SectionImageLeftSupport-module--ctaWrapper--ad739";
export var imageWrapper = "SectionImageLeftSupport-module--imageWrapper--b9c05";
export var subTitle = "SectionImageLeftSupport-module--subTitle--1815e";
export var title = "SectionImageLeftSupport-module--title--fbe46";
export var wrapper = "SectionImageLeftSupport-module--wrapper--67e94";